'use client';

import { useRef } from 'react';

import { SurveyConfig } from '@/common/constants/porsline';
import { useSurveyEmbed } from '@/common/hooks/porsline/useSurveyEmbed';

import { SurveyLoading } from './SurveyLoading';

type Props = {
  survey: SurveyConfig | null;
  onClose: () => void;
};

export function SurveyOverlay({ survey, onClose }: Props) {
  const containerRef = useRef<HTMLDivElement>(null);

  const isLoading = useSurveyEmbed({
    survey,
    containerRef,
  });

  if (!survey) return null;

  return (
    <div className="fixed inset-0 z-999999 h-dvh w-screen overflow-hidden bg-white">
      <button
        type="button"
        onClick={onClose}
        className="absolute top-3 right-3 z-1000001 flex size-10 items-center justify-center rounded-full bg-white shadow-lg transition hover:bg-gray-100"
      >
        <span className="translate-y-[3px]">✕</span>
      </button>

      <div className="relative size-full">
        <div ref={containerRef} className="size-full" />
        {isLoading && <SurveyLoading />}
      </div>
    </div>
  );
}
